import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface CompanyAccessData {
  appId: string
  linkedServer: string
  databaseName: string
  tenants: string
  audienceId: string
  secret: string
  audienceIdMobile: string
  secretMobile: string
}

export interface CompanyAccessResponse {
  status: number
  message: string
  path: string
  data: CompanyAccessData | null
}

const initialState: CompanyAccessResponse = {
  status: 0,
  message: '',
  path: '',
  data: null
}

export const backofficeCompanyAccessSlice = createSlice({
  name: 'backofficeCompanyAccess',
  initialState,
  reducers: {
    setCompanyAccess: (state, action: PayloadAction<CompanyAccessResponse>) => {
      state.status = action.payload.status
      state.message = action.payload.message
      state.path = action.payload.path
      state.data = action.payload.data
    }
  }
})

export const { setCompanyAccess } = backofficeCompanyAccessSlice.actions
export default backofficeCompanyAccessSlice.reducer 